var exports = {
  "CP": "boardSurface__yw-cmP",
  "MT": "surface__XTKUn5",
  "Qs": "content__X6LAyK",
  "zV": "busyIndicator__Goeeuy",
};

module.exports = exports;
